// src/components/settings/settingsShared.js
//
// Value helpers shared by the Settings page, the confirm sheet and History.
// Setting definitions come from the server (app_settings/registry.py).

export const sameValue = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

export function formatValue(setting, value) {
  if (value === null || value === undefined) return 'Default';
  if (Array.isArray(value)) {
    if (!value.length) return setting?.type === 'email_list' ? 'Every active admin' : 'None';
    if (setting?.options) {
      const names = Object.fromEntries(setting.options.map((o) => [o.id, o.label]));
      return value.map((v) => names[v] || v).join(', ');
    }
    return value.join(', ');
  }
  if (value === '') return 'Empty';
  if (typeof value === 'object') return 'Custom';
  if (setting?.unit) return `${value}${setting.unit === '%' ? '%' : ` ${setting.unit}`}`;
  return String(value);
}

// What the draft holds for a field, turned into what the server expects.
export function draftToValue(setting, raw) {
  if (setting.type === 'email_list') {
    return String(raw || '').split(/[\n,;\s]+/).map((s) => s.trim().toLowerCase()).filter(Boolean);
  }
  if (setting.type === 'int') return raw === '' ? raw : Number.parseInt(raw, 10);
  if (setting.type === 'float') return raw === '' ? raw : Number.parseFloat(raw);
  return raw;
}

export function valueToDraft(setting, value) {
  if (setting.type === 'email_list') return (value || []).join('\n');
  if (setting.type === 'int' || setting.type === 'float') return value === null || value === undefined ? '' : String(value);
  return value;
}

export function parseTs(ts) {
  if (!ts) return null;
  const d = new Date(String(ts).replace(' ', 'T') + 'Z');
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatWhen(ts) {
  const d = parseTs(ts);
  if (!d) return '';
  return d.toLocaleString(undefined, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}
